import { connect } from 'react-redux';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import React from 'react';

import { checkToken } from './actions/loginActions';
import routes, { PrivateRoute } from './routes';
import ServerErrorSnackbar from './components/includes/ServerErrorSnackbar';
// import EventEmitter from 'events';
// const event = new EventEmitter();
// event.setMaxListeners();

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      serverError: false,
      serverErrorOpen: false,
    };
  }

  componentDidMount() {
    this.props.checkToken();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.serverError &&
      prevProps.serverError !== this.props.serverError
    ) {
      if (
        this.props.serverError === "Cannot read property 'push' of undefined"
      ) {
        //this need to be fixed, error is from ????
        return;
      }
      this.setState({
        serverError: this.props.serverError,
        serverErrorOpen: true,
      });
    }
  }

  handleCloseServerErrorSnackbar = () => {
    this.props.resetErrorMessage();
    this.setState({ serverErrorOpen: false });
  };

  handleEraseServerError = () => {
    this.setState({ serverError: false });
  };

  render() {
    if (this.props.role === null && this.props.authenticated === null) {
      return null;
    }
    return (
      <BrowserRouter>
        <div className="page-container">
          <ServerErrorSnackbar
            message={this.state.serverError}
            open={this.state.serverErrorOpen}
            onClose={this.handleCloseServerErrorSnackbar}
            handleEraseServerError={this.handleEraseServerError}
          />
          <Switch>
            {routes.map((route, i) => {
              if (route.protected) {
                return (
                  <PrivateRoute
                    key={i}
                    exact={route.exact}
                    path={route.path}
                    component={route.component}
                    isAuthenticated={this.props.authenticated}
                    role={this.props.role}
                    allowedRoles={route.allowedRoles}
                  />
                );
              }
              return (
                <Route
                  key={i}
                  exact={route.exact}
                  path={route.path}
                  component={route.component}
                />
              );
            })}
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}
const mapStateToProps = state => {
  return {
    redirect: state.login.redirect,
    role: state.login.role,
    location: state.routerReducer.location,
    authenticated: state.login.authenticated,
    serverError: state.serverError.serverError,
  };
};
const mapDispatchToProps = dispatch => ({
  checkToken: () => {
    dispatch(checkToken());
  },
  resetErrorMessage: () => {
    dispatch({ type: 'RESET_ERROR_MESSAGE' });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
